import metaData from '../components/documentation/shared/formsMetaData'

export default {
  mixins: [metaData],
  data () {
    return {
      errorMapper: {
        string_gte: 'min',
        string_lte: 'max',
        number_gte: 'min',
        number_gt: 'min',
        number_lte: 'max',
        number_lt: 'max',
        format: 'format',
        pattern: 'pattern',
        unique: 'type',
        array_max_items: 'max',
        array_min_items: 'min',
        enum: 'allowed',
        invalid_type: 'expected',
        missing_dependency: 'dependency',
        required: 'property'
      },
      moduleDependency: {},
      SYST_Passive_TherapyArtTypes: null,
      ST_ApplicationsTypes: [
        { value: 'perkutan', text: 'Perkutan' },
        { value: 'kontakt', text: 'Kontakt' },
        { value: 'metabolisch', text: 'Metabolisch' },
        { value: 'sonstige', text: 'Sonstige' }
      ],
      ST_ZielgebietTypes_2014: [],
      ST_ZielgebietTypes_2021: [],
      TumorStatusGeneralTypes: null
    }
  },
  created () {
    this.moduleDependency = this.formsMetaData.moduleDependenciesToTumor
    this.SYST_Passive_TherapyArtTypes = this.formsMetaData.SYST_Passive_TherapyArtTypes
    this.ST_ZielgebietTypes_2014 = this.formsMetaData.ST_ZielgebietTypes2014
    this.ST_ZielgebietTypes_2021 = this.formsMetaData.ST_ZielgebietTypes2021
    this.TumorStatusGeneralTypes = this.formsMetaData.TumorStatusGeneralTypes
  },
  computed: {
    showLoginPopup () {
      return this.$store.getters.showLoginPopup
    }
  },
  methods: {
    /**
     * Set selected form in documentation on sent
     *
     * @param id The id of form
     */
    setIsSent (id) {
      if (id) {
        this.$http.patch('/documentation/formStatus/sent/' + id)
          .then(() => {
            this.$store.dispatch('setFlagToReload', this.key)
          })
          .catch(error => {
            this.handleError(error)
          })
      }
    },

    /**
     * Change background color of module header and open closed module if validation error exist while trying to complete form
     *
     * @param panelIndex The panel index of selected module
     * @param module The name of the validation-provider of selected module
     * @returns {Boolean}
     */
    openInvalidModule (panelIndex, module) {
      const valid = this.$refs[module] && this.$refs[module].flags ? this.$refs[module].flags.valid : true

      // open module, if validation errors exist and module is closed
      if (!valid && this.setIsCompletedIsTriggered && this.panel.indexOf(panelIndex) === -1) this.panel.push(panelIndex)

      // set background color of header on red if invalid
      return !valid && this.setIsCompletedIsTriggered
    },

    setDefaultValuesForNewForm () {
      const user = this.authStore.getters.getAuthUserData
      const melderId = user && user.user && user.user.cancer_form_details && user.user.cancer_form_details.melder_id

      this.$set(this.model.report_header, 'reporter', {})

      if (user && user.user && user.user.lastname && user.user.firstname && (user.user.lanr || user.user.iknr)) {
        this.$set(this.model.report_header.reporter, 'melderId', melderId || '')
        this.$set(this.model.report_header.reporter, 'name', user.user.firstname + ' ' + user.user.lastname)

        // set lanr or iknr if exist
        if (user.user.lanr) {
          this.$set(this.model.report_header.reporter, 'lanr', user.user.lanr)
        }
        if (user.user.iknr) {
          this.$set(this.model.report_header.reporter, 'iknr', user.user.iknr)
        }
      }

      this.$set(this.model.report_header, 'eigenleistung', 'J')

      switch (this.formKey) {
        case 'progress':
          // this.$set(this.model.base, 'gesamtbeurteilung_tumorstatus', 'K')
          // this.$set(this.model.base, 'verlauf_lokaler_tumorstatus', 'U')
          // this.$set(this.model.base, 'verlauf_tumorstatus_lymphknoten', 'U')
          // this.$set(this.model.base, 'verlauf_tumorstatus_fernmetastasen', 'U')
          this.$delete(this.model.base, 'untersuchungsdatum_verlauf') // date will be set with default value in backend, because of its required
          this.$delete(this.model.base, 'gesamtbeurteilung_tumorstatus')
          break
        case 'operation':
          this.$delete(this.model.base, 'op_datum') // date will be set with default value in backend, because of its required
          this.$set(this.model.report_header, 'meldeanlass', 'behandlungsende')
          this.$set(this.model.base, 'op_intention', 'K')
          this.$set(this.model.base, 'op_ops', [])
          this.$set(this.model.base.op_ops, 0, {})
          this.$set(this.model.op_komplikation, 'komplikation_nein_oder_unbekannt', 'N')
          this.$set(this.model.op_komplikation, 'kuerzel', {})
          this.$set(this.model, 'operateure', [])

          break
        case 'radiationTherapy':
          this.$set(this.model.base, 'st_intention', 'P')
          this.$set(this.model.base, 'st_stellung_op', 'O')
          this.$set(this.model, 'bestrahlung', [{}])
          this.$set(this.model.bestrahlung[0], 'st_applikationsart', {})
          this.$set(this.model.bestrahlung[0].st_applikationsart, 'perkutan', { zielgebiet: {}, gesamtdosis: {}, einzeldosis: {} })
          this.$set(this.model, 'st_nebenwirkung', {})

          break
        case 'systemicTherapy':
          // this.$set(this.model.base, 'syst_stellung_op', 'O')
          // this.$set(this.model.base, 'syst_intention', 'P')
          this.$delete(this.model.base, 'syst_beginn_datum') // date will be set with default value in backend, because of its required
          this.$set(this.model.base, 'syst_substanz', [])
          this.$set(this.model.base.syst_substanz, 0, {})
          break
        case 'tumorConference':
          this.$delete(this.model.base, 'tumorkonferenz_datum') // date will be set with default value in backend, because of its required
          this.$set(this.model.report_header, 'meldeanlass', 'behandlungsbeginn')
          this.$set(this.model.base, 'therapieempfehlung', {})
          this.$set(this.model.base.therapieempfehlung, 'typ_therapieempfehlungen', [])
          this.$set(this.model.base.therapieempfehlung.typ_therapieempfehlungen, 0, 'KW')
          break
        default:
          // register form
          this.$set(this.model.report_header, 'meldeanlass', 'diagnose')
          this.$set(this.model.diagnose, 'diagnosesicherung', '7.1')
          this.$delete(this.model.diagnose, 'diagnosedatum') // date will be set with default value in backend, because of its required
          this.$set(this.model.modul_prostata, 'kompl_post_op_clavien_dindo', 'U')
          this.$set(this.model, 'histologie', [{}])
          this.$set(this.model, 'fruehere_tumorerkrankung', [])
      }
    },

    /**
     * Set additional items on form in dependency to existing additional items of selected cancer register
     *
     * @param model
     */
    setAdditionalItemsInDocumentation (model) {
      // set additional items to form, if not exists
      (this.additionalItemsList || []).forEach(listItem => {
        if (model.report_header.zusatzitems.findIndex((item) => item.name === listItem.name) === -1) {
          const newIndex = model.report_header.zusatzitems.length

          this.$set(model.report_header.zusatzitems, newIndex, {})
          this.$set(model.report_header.zusatzitems[newIndex], 'name', listItem.name)
          this.$set(model.report_header.zusatzitems[newIndex], 'date', {})
          this.$set(model.report_header.zusatzitems[newIndex], 'value', null)
          this.$set(model.report_header.zusatzitems[newIndex], 'comment', null)
        }
      })
    },

    /**
     * Add new element to an array
     *
     * @param array The path where array is located in model
     * @param initValue The value which should be set instead of an empty object
     */
    addItem (array, initValue) {
      let arr = this.checkObjectPath(array)
      this.$set(arr, arr.length, initValue !== undefined ? initValue : {})
    },

    /**
     * Delete element from selected index
     *
     * @param array The path where array is located in model
     * @param index The index of element which should be deleted
     */
    deleteItem (array, index) {
      let arr = this.checkObjectPath(array)
      this.$delete(arr, index)
    },

    isFormDisabled () {
      return Boolean(this.model && this.model.formStatus)
    },

    /**
     * Return array-property of model
     *
     * @param path The path of property within the model
     * @returns {*}
     */
    checkObjectPath (path) {
      let obj = this.model
      let items = path.split('.')
      let arrName = items.pop()
      let self = this
      items.forEach(function (item) {
        // create object path if not exists
        if (!obj[item]) {
          self.$set(obj, item, {})
        }
        obj = obj[item]
      })
      if (!obj[arrName]) {
        // set array reactive
        this.$set(obj, arrName, [])
      }
      return obj[arrName]
    },

    /**
     * Set empty String-value of input with integer-typ to null
     *
     * @param value The value of Field
     * @param objectPath The path from model on
     * @param property The field name
     */
    refactorEmptyIntValue (value, objectPath, property) {
      if (value === '') {
        if (objectPath) {
          this.$set(this.model[objectPath], property, null)
        } else {
          this.$set(this.model, property, null)
        }
      }
    },

    /**
     * Method to show long description of a selected value with short description
     *
     * @param value The selected value
     * @param type The name of the lookup table
     * @returns {*}
     */
    getFieldValue (value, type) {
      if (this.formsMetaData && this.formsMetaData[type]) {
        if (Array.isArray(this.formsMetaData[type])) {
          let txt = ''
          this.formsMetaData[type].forEach(function (item) {
            if (item.value === value) {
              txt = item.text
            }
          })
          return txt
        } else {
          return this.formsMetaData[type][value] || ''
        }
      }

      return value
    },

    /**
     * Method to open file explorer to save report-xml on client
     *
     * @param data The generated report-xml from backend
     * @param filename The generated report-xml name
     */
    openFileExplorerToSaveReport (data, filename) {
      let blob = new Blob([data], { type: 'text/xml' })
      let link = document.createElement('a')

      link.setAttribute('type', 'hidden')
      link.href = window.URL.createObjectURL(blob)

      if (filename && filename !== '') {
        link.download = filename
      } else if (this.$options.filters['formatDate']) {
        link.download = 'oBDS_' + this.$options.filters['formatDate'](new Date(), 'YYYY-MM-DD_HHmm') + '.xml'
      } else {
        link.download = 'oBDS_' + new Date().toISOString() + '.xml'
      }

      document.body.appendChild(link)

      link.click()

      setTimeout(function () {
        link.remove()
      }, 0)
    },

    /**
     * Delete special characters in regex string to provide errors
     *
     * @param stringValue The string for regex-search in backend
     * @returns {*}
     */
    clearStringForRegexSearch (stringValue) {
      if (typeof stringValue === 'string') {
        return stringValue.replace(/[#\\"%&()/+*?;]/g, '')
      }

      return stringValue
    },

    /**
     * Show or hide selected module in documentation in dependency to icd10
     *
     * @param module {string} The name of the selected module
     * @param patientId {string} The unique id of patient
     * @returns {boolean}
     */
    showModuleInDependencyToICD10 (module, patientId) {
      let showModule = false

      if (this.moduleDependency[module] && this.$store.getters.diagnosisBaseData(patientId) && this.$store.getters.diagnosisBaseData(patientId).diagCode) {
        showModule = this.moduleDependency[module].test(this.$store.getters.diagnosisBaseData(patientId).diagCode)
      }

      return showModule
    },

    /**
     * Enable or disable possibility to input ulzeration in dependency to TNM
     *
     * @param tnm The TNM from selected form
     * @returns {boolean}
     */
    disableFieldInDependencyToTNM (tnm) {
      // if TNM is not pT1b then set value null
      if (tnm && (tnm.tnm_c_p_u_praefix_t !== 'p' || tnm.tnm_t !== '1b')) {
        this.$delete(this.model, 'ulzeration')
      }

      // return true if TNM is pT1b
      return tnm && tnm.tnm_c_p_u_praefix_t === 'p' && tnm.tnm_t === '1b'
    },

    /**
     * Check if module has filled elements
     *
     * @param module {object} The selected module
     * @returns {boolean}
     */
    isModuleFilledWithData (module) {
      let hasFilledElements = false

      // check if object exists and has elements
      if (module && typeof module === 'object' && Object.keys(module).length > 0) {
        // Iterate through elements and check if elements has values
        Object.keys(module).forEach(key => {
          // go in recursion if element is an object
          if (module[key] && typeof module[key] === 'object' && Object.keys(module[key]).length > 0) {
            hasFilledElements = this.isModuleFilledWithData(module[key]) ? true : hasFilledElements // recursion
          } else if (typeof module[key] !== 'object' && !!module[key]) {
            hasFilledElements = true
          }
        })
      }

      // if element is array and has elements, return true
      if (module && Array.isArray(module) && module.length > 0) {
        hasFilledElements = true
      }

      return hasFilledElements
    },

    /**
     * Return evaluation state of progress form
     *
     * @param form The progress form
     */
    getEvaluationForProgress (form) {
      // get total state of tumor
      const stateTotal = form?.additionalFields?.progress?.gesamtbeurteilung_tumorstatus || ''
      let textString = ''

      if (stateTotal !== 'P') {
        const evaluation = this.TumorStatusGeneralTypes.find(elem => elem.value === stateTotal)
        textString += evaluation?.short || ''
      } else {
        const statePrimary = form?.additionalFields?.progress?.verlauf_lokaler_tumorstatus || ''
        const stateLymph = form?.additionalFields?.progress?.verlauf_tumorstatus_lymphknoten || ''
        const stateMetastases = form?.additionalFields?.progress?.verlauf_tumorstatus_fernmetastasen || ''
        const metastasesExist = form?.additionalFields?.progress?.fernmetastase && form?.additionalFields?.progress?.fernmetastase.length > 0

        // progression primary tumor
        if (statePrimary === 'P' || statePrimary === 'r') {
          textString += 'Progression Primärtumor'
          // progression lymph nodes
        } else if (stateLymph === 'P' || stateLymph === 'R') {
          textString += 'Progression Lymphknoten'
          // progression distance metastases, no new metastasis exists
        } else if (stateMetastases === 'P' || stateMetastases === 'R' && !metastasesExist) {
          textString += 'Progression Fernmetastase'
          // new distance metastases
        } else if (stateMetastases === 'R' && metastasesExist) {
          textString += 'Neue Fernmetastase'
        } else {
          const evaluation = this.TumorStatusGeneralTypes.find(elem => elem.value === stateTotal)
          textString += evaluation?.short || ''
        }
      }

      return textString
    },

    /**
     * Return kind of application of radiation as short text
     *
     * @param form The radiation therapy form
     */
    getKindOfApplication (form) {
      return Object.keys(form.additionalFields.radiationTherapy.bestrahlung.st_applikationsart)[0]
    },

    /**
     * Return destination of radiation as short text
     *
     * @param form The radiation therapy form
     */
    getDestinationOfRadiation (form) {
      let returnValue = ''

      // add kind of application, if exists
      if (form.additionalFields.radiationTherapy.bestrahlung && form.additionalFields.radiationTherapy.bestrahlung.length > 0) {

        form.additionalFields.radiationTherapy.bestrahlung.forEach((application, index) => {
          let kindOfApplication = Object.keys(application.st_applikationsart)[0]

          if (kindOfApplication) {
            returnValue +=  this.ST_ApplicationsTypes.find(elem => elem.value === kindOfApplication).text

            // add destination in dependency to version, if exists
            if (application.st_applikationsart[kindOfApplication].zielgebiet && Object.keys(application.st_applikationsart[kindOfApplication].zielgebiet).length === 1) {
              const version = Object.keys(application.st_applikationsart[kindOfApplication].zielgebiet)[0]
              const listOfDestination = version === 'code_version_2021' ? this.ST_ZielgebietTypes_2021 : this.ST_ZielgebietTypes_2014
              const destination = listOfDestination.find(elem => elem.value === application.st_applikationsart[kindOfApplication].zielgebiet[version])

              if (destination?.text) {
                returnValue += ' - ' + destination.text
              }
            }

            if (index !== form.additionalFields.radiationTherapy.bestrahlung.length - 1) returnValue += ' | '
          }
        })
      }

      return returnValue
    },

    /**
     * Return string with operations
     *
     * @param form The operation form
     */
    getShortTextOfOperation (form) {
      const ops = form?.additionalFields?.operation?.op_ops || []
      let textString = ''

      ops.forEach((op, index) => {
        if (op.description) {
          const descArray = op.description.split(':')

          // get the second element in description text, fallback is first element
          const operationText = descArray[1] ? descArray[1].trim() : descArray[0].trim()

          // add operation to string, if not already exists in string
          if (textString.indexOf(operationText) === -1) {
            if (index > 0) {
              textString += ', '
            }

            textString += operationText
          }
        }
      })

      return textString
    },

    /**
     * Display agents of report reasons found in import or for report
     *
     * @param agents Array with agents from form
     */
    getAgentList (agents) {
      agents = agents || []
      let textString = ''
      const filteredAgents = agents.filter(agent => agent.bezeichnung)
      const count = filteredAgents.length

      filteredAgents.forEach((agent, index) => {
        if (agent && agent.bezeichnung) {
          textString += agent.bezeichnung

          if (index < count - 1) {
            textString += ', '
          }
        }
      })

      return [
        {
          value: agents,
          text: textString
        }
      ]
    },

    /**
     * Return string with kind of therapy of selected systemic therapy
     *
     * * @param form The systemic therapy form
     */
    getKindOfSystTherapyAsString (form) {
      const therapieValue = form?.additionalFields?.systemicTherapy?.syst_therapieart || null
      let textString = ''

      const element = this.SYST_Passive_TherapyArtTypes.find(elem => elem.value === therapieValue)

      if (element?.short) {
        textString += element.short
      }

      return textString
    },

    /**
     * Set ICDO-Code after ICD10
     */
    setICDOAfterICD10 (icd10, icdoVersion) {
      // icd10 code must be set and must be a c-diagnosis up to 8 on first segment
      const isAssignableCode = icd10 && icd10.code && icd10.code.match(/^C[0-7]|C80/)

      let code = ''

      // set icd-o only if not exists and icd10 has the right match
      if (isAssignableCode) {
        const codeLength = icd10 && icd10.code && icd10.code.length

        if (codeLength === 3) {
          code = icd10.code + '.9'
        } else if (codeLength === 5) {
          code = icd10.code
        }
      }

      if (icd10 && icd10.code && this.PairedAdditionalTumors[icd10.code]) {
        code = this.PairedAdditionalTumors[icd10.code]
      }

      if (icd10 && icd10.code && this.NotPairedAdditionalTumors[icd10.code]) {
        code = this.NotPairedAdditionalTumors[icd10.code]
      }

      // set icd-o if code exists or delete content of icd-o
      if (code) {
        let config = {
          opts: {
            limit: 30
          },
          query: {
            searchValue: code
          }
        }

        // if icd-10 version is set, send it to backend
        const foundVersion = this.Primaertumor_ICD_O_VersionTypes.find(elem => elem.value === icdoVersion)

        if (foundVersion?.misdValue) {
          config.query.version = foundVersion.misdValue
        }

        this.$http.get('/icdO?config=' + JSON.stringify(config))
            .then(res => {
              if (res?.data?.items && res.data.items.length === 1) {
                this.$set(this.model, 'primaertumor_topographie_icd_o', res.data.items[0].code)
                this.$set(this.model, 'primaertumor_topographie_icd_freitext', res.data.items[0].description)
                this.$set(this.model, 'primaertumor_topographie_icd_o_version', icdoVersion || this.formsMetaData.ICDO_Version)
              } else {
                this.$set(this.model, 'primaertumor_topographie_icd_o', code)
                this.$set(this.model, 'primaertumor_topographie_icd_freitext', icd10.description)
                this.$set(this.model, 'primaertumor_topographie_icd_o_version', icdoVersion || this.formsMetaData.ICDO_Version)
              }
            })
            .catch(this.NotifyError)
      } else {
        this.$set(this.model, 'primaertumor_topographie_icd_o', null)
        this.$set(this.model, 'primaertumor_topographie_icd_freitext', null)
        this.$set(this.model, 'primaertumor_topographie_icd_o_version', null)
      }
    },

    /**
     * Format text for metastasis in panel header of import-/report-form
     *
     * @param item The form
     */
    formatMetastasisText (item) {
      const type = (this.FM_LokalisationTypes.find(localization => localization.value === item.localization) || {}).text
      return type ? type + '(' + item.code + ')' : item.code
    },

    /**
     * Format view of date of systemic therapy in list-view of possible report reasons
     *
     * @param listElement The element of the date list
     */
    formatDateOfSystemicTherapy (listElement) {
      let returnValue = listElement.date ? this.$options.filters['formatDate'](listElement.date, 'DD.MM.YYYY') : ''

      // extend label if agents exists
      if (listElement.syst_substanz && listElement.syst_substanz.length > 0) {
        let textString = ''
        const filteredAgents = listElement.syst_substanz.filter(agent => agent.bezeichnung)
        const count = filteredAgents.length

        filteredAgents.forEach((agent, index) => {
          if (agent && agent.bezeichnung) {
            textString += agent.bezeichnung

            if (index < count - 1) {
              textString += ', '
            }
          }
        })

        returnValue += ' (' + textString + ')'
      } else if (listElement.syst_therapieart && ['AS', 'WS', 'WW'].indexOf(listElement.syst_therapieart) > -1) {
        // extend label if passive therapy exists, there can only be on kind in therapy in therapy-object
        let nameOfKindOfTherapy = this.SYST_TherapyArtTypes.find(elem => elem.value === listElement.syst_therapieart).short

        returnValue += ' (' + nameOfKindOfTherapy + ')'
      }

      if (returnValue.endsWith('()')) {
        returnValue = returnValue.replace('()', '(' + this.$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_LIST_LINKED_THERAPY_NO_CONTENT') + ')')
      }
      return returnValue
    },

    /**
     * Format view of date of radiation therapy in list-view of possible report reasons
     *
     * @param listElement The element of the date list
     */
    formatDateOfRadiationTherapy (listElement) {
      let returnValue = listElement.date ? this.$options.filters['formatDate'](listElement.date, 'DD.MM.YYYY') : ''

      // add kind of application, if exists
      if (listElement.applikationsart && listElement.applikationsart.length > 0) {

        returnValue += ' ['

        listElement.applikationsart.forEach((application, index) => {
          // get name of type e.g. perkutan
          let kindOfApplicationType = application.st_applikationsart ? Object.keys(application.st_applikationsart)[0] : Object.keys(application)[0]
          // get the object of kind of application
          const kindOfApplication = application.st_applikationsart ? application.st_applikationsart : application

          if (kindOfApplicationType) {
            returnValue +=  this.ST_ApplicationsTypes.find(elem => elem.value === kindOfApplicationType).text

            // add destination in dependency to version, if exists
            if (kindOfApplication[kindOfApplicationType].zielgebiet && Object.keys(kindOfApplication[kindOfApplicationType].zielgebiet).length === 1) {
              const version = Object.keys(kindOfApplication[kindOfApplicationType].zielgebiet)[0]
              const listOfDestination = version === 'code_version_2021' ? this.ST_ZielgebietTypes_2021 : this.ST_ZielgebietTypes_2014
              const destination = listOfDestination.find(elem => elem.value === kindOfApplication[kindOfApplicationType].zielgebiet[version])

              if (destination?.text) {
                returnValue += ' - ' + destination.text
              }
            }

            if (index !== listElement.applikationsart.length - 1) returnValue += ' | '
          }
        })

        returnValue += ']'
      }

      return returnValue
    },

    /**
     * Filter versions by removing unsupported types
     */
    filterVersions (type) {
      let versions = []
      let origins = []
      let url = ''

      switch (type) {
        case 'icd10':
          url = '/icd10/availableVersions'
          origins = this.formsMetaData.ICD_VersionTypes
          break
        case 'ops':
          url = '/ops/availableVersions'
          origins = this.formsMetaData.OP_OPS_VersionTypes
          break
        case 'icdO':
          url = '/icdO/availableVersions'
          origins = this.formsMetaData.Morphologie_ICD_O_VersionTypes
          break
        default:
          return versions
      }

      this.$http.get(url)
        .then(res => {
          if (Array.isArray(res.data)) {
            origins.forEach(version => {
              if (res.data.find(elem => elem === version.misdValue || version.value === 'Sonstige')) {
                versions.push(version)
              }
            })
          }
        })
        .catch()
      return versions
    },

    /**
     * Return object with date of last day of ignoring in import and type of ignoring
     *
     * @param selection The selected value from duration list
     * @returns {{type: string, date: Date}}
     */
    returningDateForBlackList (selection) {
      if (selection) {
        let date = new Date()
        let type = 'addUntil'

        switch (selection) {
          case 'M': // till the end of month
            date = new Date(date.getFullYear(), date.getMonth() + 1, 0, 12)
            break
          case 'V': // for 3 month
            date = new Date(date.getFullYear(), date.getMonth() + 3, date.getDate(), 12)
            break
          case 'H': // for 6 month
            date = new Date(date.getFullYear(), date.getMonth() + 6, date.getDate(), 12)
            break
          case 'J': // for 1 year
            date = new Date(date.getFullYear() + 1, date.getMonth(), date.getDate(), 12)
            break
          case 'P': // permanent ignoring
            date = null
            type = 'addPermanent'
            break
          default:
            // default is "E", till the end of year
            date = new Date(date.getFullYear(), 11, 31, 12)
        }

        return {type: type, date: date}
      }
    }
  }
}
